import firebase from "firebase/app";
import "@firebase/messaging";
import "@firebase/functions";

class Firebase {
  constructor() {
    const config = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID,
    };
    firebase.initializeApp(config);

    if (firebase.messaging.isSupported()) {
      firebase
        .messaging()
        .usePublicVapidKey(process.env.VUE_APP_FIREBASE_MESSAGING_PUBLIC_KEY);
    }
  }

  checkNotificationEnabled = () => {
    return !!window.localStorage.getItem("FIREBASE_TOKEN");
  };

  isNotificationSupported = () => {
    return firebase.messaging.isSupported();
  }

  requestUserNotificationPermission = async (): Promise<string | null> => {
    let token = null;
    await firebase.messaging().requestPermission();
    token = await firebase.messaging().getToken();
    window.localStorage.setItem("FIREBASE_TOKEN", token || "");
    return token;
  };

  sendNotification = async (notificationType: string) => {
    const token = window.localStorage.getItem("FIREBASE_TOKEN") || "";
    if (token === "") {
      return;
    }

    const sendNotification = firebase
      .app()
      .functions("asia-northeast1")
      .httpsCallable("sendNotification");
    await sendNotification({
      token,
      notificationType
    });
  };
}
const fire = new Firebase();
export default fire;
